function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "af9f6089-e9c3-427b-8ce8-494b7a282d56",
  d: "M107.9,78.78c-15.48,0-29.29-7-33.59-17.15A1.44,1.44,0,0,1,77,60.51c3.85,9.06,16.58,15.4,30.94,15.4a43.59,43.59,0,0,0,19.4-4.3,1.44,1.44,0,0,1,1-.1L138.07,74l-2-8.06a1.43,1.43,0,0,1,.28-1.26A15.28,15.28,0,0,0,140,54.93c0-9.37-9.66-17.68-23.5-20.21a1.44,1.44,0,0,1,.52-2.83c15.22,2.78,25.85,12.26,25.85,23a18.15,18.15,0,0,1-3.88,11l2.46,9.72a1.43,1.43,0,0,1-1.75,1.74l-11.6-2.93A46.77,46.77,0,0,1,107.9,78.78Z",
  transform: "translate(-30.87 -2.74)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "af9f6089-e9c3-427b-8ce8-494b7a282d56",
  d: "M74.36,61.81a58.19,58.19,0,0,1-25.29-5.48L34.4,60a1.44,1.44,0,0,1-1.75-1.75l3.12-12.35a22.43,22.43,0,0,1-4.9-13.66C30.87,16,50.38,2.74,74.36,2.74S117.85,16,117.85,32.28,98.34,61.81,74.36,61.81ZM49.23,53.37a1.43,1.43,0,0,1,.64.15,55,55,0,0,0,24.49,5.42c22.4,0,40.61-12,40.61-26.66S96.76,5.61,74.36,5.61s-40.61,12-40.61,26.67a19.84,19.84,0,0,0,4.71,12.43A1.44,1.44,0,0,1,38.73,46L36,56.66l12.84-3.25A1.47,1.47,0,0,1,49.23,53.37Z",
  transform: "translate(-30.87 -2.74)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "af9f6089-e9c3-427b-8ce8-494b7a282d56",
  d: "M74.36,38.9A6.63,6.63,0,1,1,81,32.28,6.64,6.64,0,0,1,74.36,38.9Zm0-10.38a3.76,3.76,0,1,0,3.75,3.76A3.76,3.76,0,0,0,74.36,28.52Z",
  transform: "translate(-30.87 -2.74)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "af9f6089-e9c3-427b-8ce8-494b7a282d56",
  d: "M54.67,38.9a6.63,6.63,0,1,1,6.62-6.62A6.63,6.63,0,0,1,54.67,38.9Zm0-10.38a3.76,3.76,0,1,0,3.75,3.76A3.77,3.77,0,0,0,54.67,28.52Z",
  transform: "translate(-30.87 -2.74)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "af9f6089-e9c3-427b-8ce8-494b7a282d56",
  d: "M94.05,38.9a6.63,6.63,0,1,1,6.63-6.62A6.63,6.63,0,0,1,94.05,38.9Zm0-10.38a3.76,3.76,0,1,0,3.76,3.76A3.76,3.76,0,0,0,94.05,28.52Z",
  transform: "translate(-30.87 -2.74)"
});

var SvgMessages = function SvgMessages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f460f8d2-2769-4edf-b4e6-3f6df9c94df5",
    "data-name": "Layer 15",
    viewBox: "0 0 112 76.04",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messages.bee06f14.svg";
export { ForwardRef as ReactComponent };